import React from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import { IntlShape, injectIntl } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/ManagerHomePage/PvIndexed/messages';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import EmptyBloc from 'components/EmptyBloc';
import PendingFiles from 'components/SahamIcons/PendingFiles';
import ActionButton from 'components/Buttons/ActionButton';
import CardTitle from 'containers/common/Card/CardTitle';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import pdf from 'images/pdf.svg';
import download from 'images/download.svg';

const Container = styled.div`
  .container {
    padding-right: 20px;
  }
  .subContainer {
    background-color: #f7f7f7;
    padding: 5px;
    padding-right: 10px;
    padding-left: 10px;
    border-radius: 3px;
    margin-top: 5px;
    max-height: 245px;
    overflow-y: scroll;
  }
  .table {
  }
  .ChevronRightIcon {
    fill: #384164;
  }
  .headerTitle {
    text-align: left;
    font-size: 12px;
    letter-spacing: 0;
    color: #000000de;
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 0px;
    font-weight: Medium;
  }
  .row {
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-weight: Regulat;
    font-size: 13px;
    color: #2b2727;
  }
  .filesContainer {
    margin-top: 5px;
    margin-bottom: 10px;
  }

  .moreClaimsButton {
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 12px;
    opacity: 1;
    padding-left: 10px;
    font-weight: Bold;
  }
  .cardAction {
  }
  .CardContent {
  }
  .tableRow {
    cursor: pointer;
  }
  .button {
    display: none;
    margin-left: 10px;
    margin-top: -8px;
  }

  .cardContentFiles {
    padding: 18px;
    height: 55px;
    width: 456px;
  }
  .cardContentFiles:hover + .button {
    display: inline-block;
    left: 10px;
    position: relative;
  }
  .classGrid {
    margin-top: -8px;
    animation-duration: 4s;
  }
  .transition {
  }
  .ChevronRightIconOpen {
    margin-left: 10px;
    fill: white;
  }
  .img {
    margin-right: 5px;
    margin-top: -3px;
    width: '15px';
    height: '17px';
  }
`;
const pdfFiles = [
  {
    id: 1,
    title: '1600428303434-116.pdf',
  },
  {
    id: 2,
    title: '1600428303434-117.pdf',
  },
  {
    id: 3,
    title: '1600428303434-119.pdf',
  },
  {
    id: 4,
    title: '1600428303434-120.pdf',
  },
];
export interface PvIndexedProps {
  intl: IntlShape;
}

const PvIndexed: React.FC<PvIndexedProps> = (props): JSX.Element => {
  return (
    <Container>
      <Card className="container">
        <CardContent className="CardContent">
          <>
            <CardTitle
              count={pdfFiles.length}
              message={translate({ ...messages.title }, props)}
            />
            <div className="subContainer">
              {!isEmpty(pdfFiles) ? (
                <>
                  {pdfFiles.map(element => (
                    <Card key={element.id} className="filesContainer">
                      <CardContent className="cardContentFiles">
                        <Grid container direction="row" justify={'center'}>
                          <Grid item xs={8}>
                            <img
                              width={'15px'}
                              height={'17px'}
                              src={pdf}
                              alt="pdf"
                              className={'img'}
                            />
                            {element.title}
                          </Grid>

                          <Grid item xs={1}>
                            <img
                              width={'15px'}
                              height={'15px'}
                              src={download}
                              alt="download"
                            />
                          </Grid>
                          <Grid item xs={3} className={'classGrid'}>
                            <PrimaryButton
                              onClick={pushTo(PAGES.IDENTIFICATION_PV)}
                              righticon={
                                <ChevronRightIcon
                                  className={'ChevronRightIconOpen'}
                                />
                              }
                              background={'#0075C9'}
                              border={'#0075C9'}
                              titlecolor={'#FFFFFF'}
                              height={'36px'}
                              title={translate(
                                { ...messages.openPvTitle },
                                props,
                              )}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  ))}
                </>
              ) : (
                <EmptyBloc
                  filetitle={translate(
                    { ...messages.noPendingFilesMessage },
                    props,
                  )}
                  fileText={translate(
                    { ...messages.noPendingFilesTitle },
                    props,
                  )}
                >
                  <PendingFiles />
                </EmptyBloc>
              )}
            </div>
          </>
        </CardContent>

        <CardActions className="cardAction">
          <ActionButton
            size="small"
            title={translate({ ...messages.displayAllClaimsButton }, props)}
            onClick={pushTo(PAGES.MANAGER_PENDING_CLAIMS)}
            righticon={<ChevronRightIcon className="ChevronRightIcon" />}
          />
        </CardActions>
      </Card>
    </Container>
  );
};
export default injectIntl(PvIndexed);
